module.exports = __webpack_public_path__ + "img/HAZEL_Logo_final_brown_tranparent_large.973b9295.png";